import {
  Image,
  PDFDownloadLink,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import { Download } from "lucide-react";
import React from "react";
import { Button } from "../../ui/button";
import GenericPDFDocument from "../GenericPDFDocument";

const styles = StyleSheet.create({
  section: {
    marginBottom: 16,
    paddingBottom: 8,
    borderBottom: "1px solid #ccc",
    gap: 20,
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 700,
    marginBottom: 8,
    backgroundColor: "#0052FD10",
    padding: 4,
  },
  label: {
    fontSize: 10,
    color: "#888",
    fontWeight: 500,
  },
  value: {
    fontSize: 12,
    color: "#222",
    fontWeight: 600,
    marginBottom: 2,
  },
});

const DownloadImagingForm = ({ displayData, appointmentId }) => {
  console.log("displayData :", displayData);
  const generatePDFContent = () => [
    // Provider Information
    <View key="provider" style={styles.section}>
      <Text style={styles.sectionTitle}>Provider Information</Text>
      <View style={{ flexDirection: "row", flexWrap: "wrap", gap: 20 }}>
        <View style={{ width: "45%", gap: 4 }}>
          <Text style={styles.label}>Provider Name</Text>
          <Text style={styles.value}>
            {(displayData.appointment.doctor.firstName || "N/A") +
              " " +
              (displayData.appointment.doctor.lastName || "N/A")}
          </Text>
        </View>
        <View style={{ width: "45%", gap: 4 }}>
          <Text style={styles.label}>NPI</Text>
          <Text style={styles.value}>
            {displayData.appointment.doctor.medicalLicenseNumber || "N/A"}
          </Text>
        </View>
        <View style={{ width: "45%", gap: 4 }}>
          <Text style={styles.label}>Office Name</Text>
          <Text style={styles.value}>Doc Mobil</Text>
        </View>
        <View style={{ width: "45%", gap: 4 }}>
          <Text style={styles.label}>Office Address</Text>
          <Text style={styles.value}>
            256 Ennisbrook Drive Se, Smyrna, GA 30082
          </Text>
        </View>
        <View style={{ width: "45%", gap: 4 }}>
          <Text style={styles.label}>Contact Number</Text>
          <Text style={styles.value}>
            {displayData.appointment.doctor.contactNumber || "N/A"}
          </Text>
        </View>
      </View>
    </View>,
    // Imaging Form Details
    <View key="details" style={styles.section}>
      <Text style={styles.sectionTitle}>Imaging Form Details</Text>
      <View style={{ flexDirection: "row", flexWrap: "wrap", gap: 20 }}>
        <View style={{ width: "45%", gap: 4 }}>
          <Text style={styles.label}>Form ID</Text>
          <Text style={styles.value}>{displayData?.id || "N/A"}</Text>
        </View>
        <View style={{ width: "45%", gap: 4 }}>
          <Text style={styles.label}>Appointment ID</Text>
          <Text style={styles.value}>
            {displayData?.appointmentId || appointmentId || "N/A"}
          </Text>
        </View>
        <View style={{ width: "45%", gap: 4 }}>
          <Text style={styles.label}>Created Date</Text>
          <Text style={styles.value}>
            {displayData?.createdAt
              ? new Date(displayData.createdAt).toLocaleDateString()
              : "N/A"}
          </Text>
        </View>
        <View style={{ width: "45%", gap: 4 }}>
          <Text style={styles.label}>Last Updated</Text>
          <Text style={styles.value}>
            {displayData?.updatedAt
              ? new Date(displayData.updatedAt).toLocaleDateString()
              : "N/A"}
          </Text>
        </View>
      </View>
    </View>,
    // Imaging Request Details
    <View key="request" style={styles.section}>
      <Text style={styles.sectionTitle}>Imaging Request Details</Text>
      <View style={{ flexDirection: "column", gap: 12 }}>
        <View style={{ gap: 4 }}>
          <Text style={styles.label}>Services Requested</Text>
          <Text style={styles.value}>
            {displayData?.servicesRequested || "N/A"}
          </Text>
        </View>
        {displayData?.specialInstructions && (
          <View style={{ gap: 4 }}>
            <Text style={styles.label}>Special Instructions</Text>
            <Text style={styles.value}>{displayData.specialInstructions}</Text>
          </View>
        )}
        <View style={{ gap: 4 }}>
          <Text style={styles.label}>Diagnosis/Indications</Text>
          <Text style={styles.value}>{displayData?.diagnosis || "N/A"}</Text>
        </View>
      </View>
    </View>,
    // Signature and Created Date
    <View
      key="signature-row"
      style={{
        flexDirection: "row",
        justifyContent: "space-between",
        marginTop: 20,
      }}
    >
      <View>
        <Text
          style={{
            fontSize: 16,
            fontWeight: 700,
            color: "#1E1E1E",
            marginBottom: 8,
          }}
        >
          Signature
        </Text>
        {displayData?.appointment?.doctor?.signature?.url ? (
          <View style={{ width: 150, marginLeft: -20 }}>
            <Image
              src={`${displayData.appointment.doctor.signature.url}?ext=.png`}
              style={{ width: 150, objectFit: "contain" }}
            />
          </View>
        ) : (
          <Text style={{ fontSize: 12, color: "#888" }}>
            No signature available
          </Text>
        )}
      </View>
      <View>
        <Text style={{ fontSize: 14, fontWeight: 600 }}>Created Date</Text>
        <Text style={{ fontSize: 14, fontWeight: 600 }}>
          {displayData?.createdAt
            ? new Date(displayData.createdAt).toLocaleDateString()
            : "N/A"}
        </Text>
      </View>
    </View>,
  ];

  return (
    <PDFDownloadLink
      document={
        <GenericPDFDocument heading="Imaging Request Form">
          {generatePDFContent()}
        </GenericPDFDocument>
      }
      fileName={`imaging_form_${appointmentId}.pdf`}
    >
      {({ loading: pdfLoading }) => (
        <Button variant="primary" disabled={pdfLoading}>
          <Download className="mr-2 h-4 w-4" />
          {pdfLoading ? "Preparing PDF..." : "Download"}
        </Button>
      )}
    </PDFDownloadLink>
  );
};

export default DownloadImagingForm;
